import { HistoryModel } from "../../common/models/global.typing";
import { IPageFilterModel, PagedRow } from "../../home/models/PageTypes";
import { InvoiceStatus } from "../../invoices/models/InvoiceModel";
import { createProduct, ProductModel } from "../../products/models/ProductModel";
import { createWarehouse, Region, WarehouseModel } from "../../products/models/WarehouseModel";

export enum OrderStatus {
    all = 0,
    request = 1,
    quote = 2,
    orderPending = 3,
    orderApproved = 4,
    canceled = 5,
    declined = 6,
    completed = 7,
    closed = 8
}

export enum OrderRejectReason {
    none = 0,
    changeMind = 1,
    damaged = 2,
    outOfStock = 3,
    priceTooHigh = 4,
    waitTooLong = 5
}

export enum OrderTracking {
    none = 0,
    placedOnline = 1,
    inForeignStock = 2,
    shippedToDestination = 3,
    arrivedDestination = 4,
    readyForDelivery = 5,
    outForDelivery = 6,
    delivered = 7
}

export enum TrackingStatus {
    inCompleted = 0,
    inProgress = 1,
    completed = 2
}

export enum OrderRequestType {
    all = 0,
    immediate = 1,
    scheduled = 2,
    waitForOthers = 3,
    checkMoreItems = 4,
    preOrder = 5
}

export interface OrderTrackingInfo {
    order: string;
    key: string;
    name: string;
    status: TrackingStatus;
}

export interface NewOrderModel {
    customerId: number;
    customer: string;
    link: string;
    qty: number;
    note: string;
}

export const createNewOrder = (): NewOrderModel => ({
    customerId: 0,
    customer: "",
    link: "",
    qty: 0,
    note: ""
});

export interface ApproveOrderModel {
    id: number;
    status: OrderStatus;
    reason?: OrderRejectReason;
    tracking?: OrderTracking;
    note?: string;
}

export interface EditOrderModel {
    id: number;
    price: number;
    qty: number;
    rate: number;
    domesticShipping: number;
    chargeWeight: number;
    shippingRate: number;
    note?: string;
    trackingNo?: string;
}

export const createEditOrder = (): EditOrderModel => ({
    id: 0,
    price: 0,
    qty: 0,
    rate: 0,
    domesticShipping: 0,
    chargeWeight: 0,
    shippingRate: 0,
    note: ""
});

export interface OrderModel extends EditOrderModel, PagedRow {
    customerId: number;
    customer: string;
    userId?: string;
    invoiceId?: string;
    holdPayment: number;
    orderDate: Date;
    status: OrderStatus;
    reason?: OrderRejectReason;
    tracking?: OrderTracking;
    earningPointRate: number;
    product: ProductModel;
    warehouse: WarehouseModel;
    trackings: OrderTrackingInfo[];

    invoiceStatus?: InvoiceStatus;
    confirmedWithCustomer: boolean;
    fromWarehouseId: number;
    fromWarehouse: string;
    region?: Region;
    addressId?: number;
    phoneId?: number;
    requestType: OrderRequestType;
    requestDate: Date;
    imageUrl: string;
    barcode: string;
    histories: HistoryModel[];
}

export const createOrderModel = (): OrderModel => ({
    id: 0,
    price: 0,
    qty: 0,
    rate: 0,
    domesticShipping: 0,
    chargeWeight: 0,
    shippingRate: 0,
    customerId: 0,
    customer: "",
    holdPayment: 0,
    orderDate: new Date(0),
    status: OrderStatus.request,
    earningPointRate: 0,
    product: createProduct(),
    warehouse: createWarehouse(),
    trackings: [],

    confirmedWithCustomer: false,
    fromWarehouseId: 0,
    fromWarehouse: "",
    requestType: OrderRequestType.immediate,
    requestDate: new Date(0),
    imageUrl: "",
    barcode: "",
    histories: []
});

export interface OrderFilterModel extends IPageFilterModel {
    customerId: number;
    customer?: string;
    isAllWarehouses: boolean;
    isOpen: boolean;
    isUnInvoiced: boolean;
    warehouseId: number;
    status: OrderStatus;
    reason: OrderRejectReason;
    tracking: OrderTracking;
    requestType: OrderRequestType;
}

export interface ChangeWebsiteOrderModel {
    id: number;
    websiteId?: number;
    earningPointRate: number;
}